module.exports = __webpack_public_path__ + "static/media/opal-v4.0bda4bc7.jpg";